import React, {PureComponent} from "react"

import {injectIntl, getResolvedMessage} from "@irati/utils/lang"
import onEnter from "@irati/utils/onEnter"

import {TagElement} from "./styled"

interface Props {
  name: string
  className?: string
  selected?: boolean
  tag?: boolean
  onClick?: () => void
  count?: number
  isWellness?: boolean
}

export class Tag extends PureComponent<Props> {
  static defaultProps = {
    onClick: () => {}
  }

  render() {
    const {className, name, count, selected, tag, onClick, isWellness} = this.props
    return (
      <TagElement
        className={className}
        isWellness={isWellness}
        selected={selected}
        tag={tag}
        tabIndex={0}
        role="button"
        onClick={onClick}
        onKeyPress={(e) => onEnter(e, onClick)}
        data-test-name={name}
        data-test-selected={selected ? "true" : "false"}>
        {getResolvedMessage(this, "name")}
        {selected && tag && <span style={{fontWeight: "normal", paddingLeft: "5px"}}>×</span>}
      </TagElement>
    )
  }
}

export default injectIntl(Tag, {withRef: true})
